var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { POST_SHADOW } from '../../../../constants/theme';
import { RetryButton, VideoErrorCentered } from './videoblock';
import { Wrap } from '../editor/EditorToolbar/styles';
import { GeneralEditorOverlay } from '../editor/EditorOverlayNew/GeneralEditorOverlay';
import useCommonProps from '../../../../hooks/useCommonProps';
var VideoWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  iframe {\n    width: 100%;\n    height: ", "px;\n    box-shadow: ", ";\n  }\n"], ["\n  width: 100%;\n  iframe {\n    width: 100%;\n    height: ", "px;\n    box-shadow: ", ";\n  }\n"])), function (props) { return props.height; }, function (_a) {
    var viewType = _a.viewType;
    return viewType === 'shadow' ? POST_SHADOW : 'none';
});
var progressAnim = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    from {\n      width: 0%;\n    }\n\n    to {\n      width: 100%;\n    }\n"], ["\n    from {\n      width: 0%;\n    }\n\n    to {\n      width: 100%;\n    }\n"])));
var VideoError = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 30px;\n  line-height: 40px;\n  color: red;\n  padding: 20px;\n"], ["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 30px;\n  line-height: 40px;\n  color: red;\n  padding: 20px;\n"])));
var checkAudioType = function (link) {
    var bcType = /^.*(bandcamp).*$/;
    var scType = /^.*(sound).*$/;
    var mbType = /^.*(mubert).*$/;
    if (link.match(bcType) !== null) {
        return 'bc';
    }
    if (link.match(scType) !== null) {
        return 'sc';
    }
    if (link.match(mbType) !== null) {
        return 'mb';
    }
    return 'nodata';
};
var AudioPost = function (props) {
    var post = props.post, isEditable = props.isEditable, colorStyle = props.colorStyle, dragHandleProps = props.dragHandleProps, viewType = props.viewType;
    var opts = {
        playerVars: {
            autoplay: 1
        }
    };
    var _a = useState(false), error = _a[0], setError = _a[1];
    var _b = useState(false), isVideo = _b[0], toggleVideo = _b[1];
    var _c = useState(200), videoHeight = _c[0], setVideoHeight = _c[1];
    var _d = useState(''), videoType = _d[0], setVideoType = _d[1];
    var _e = useState(''), audioLink = _e[0], setAudioLink = _e[1];
    var isFeed = useCommonProps().isFeed;
    useEffect(function () {
        var typedLink = checkAudioType(post.text);
        var link = post.text.match(/<iframe\s+.*?\s+src=(".*?").*?<\/iframe>/);
        setAudioLink(link);
        setVideoType(typedLink);
    }, []);
    var onError = function () { return setError(true); };
    if (error) {
        return (React.createElement(Wrap, { noBg: true, viewType: viewType },
            React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, withoutDrag: isFeed, dragHandleProps: dragHandleProps }),
            React.createElement(VideoWrap, { colorStyle: colorStyle, viewType: viewType },
                React.createElement(VideoErrorCentered, { colorStyle: colorStyle },
                    "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
                    React.createElement(RetryButton, { onClick: function () { return setError(false); } }, "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437")))));
    }
    if (audioLink !== null) {
        if (videoType === 'bc') {
            var updatedLink = audioLink[1].substring(1, audioLink[1].length - 1);
            console.log('updatedLink', updatedLink);
            return (React.createElement(Wrap, { noBg: true, viewType: viewType },
                React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, dragHandleProps: dragHandleProps }),
                React.createElement(VideoWrap, { height: videoHeight },
                    React.createElement("iframe", { style: {
                            border: 0,
                            width: '100%',
                            height: '120px',
                            background: 'transparent'
                        }, src: updatedLink, seamless: true, onError: onError }))));
        }
        if (videoType === 'mb') {
            var updatedLink = audioLink[1].substring(1, audioLink[1].length - 1);
            return (React.createElement(Wrap, { noBg: true, viewType: viewType },
                React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, dragHandleProps: dragHandleProps }),
                React.createElement(VideoWrap, { height: videoHeight },
                    React.createElement("iframe", { width: '380', height: '380', className: 'mubert-iframe mubert-widget', src: updatedLink, frameBorder: '0', allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', allowFullScreen: true, onError: onError }))));
        }
        if (videoType === 'sc') {
            var updatedLink = audioLink[1].substring(1, audioLink[1].length - 1);
            var scReg = post.text.match(/height="\s*(\d+)"/);
            var scHeight = void 0;
            if (scReg) {
                scHeight = +scReg[1];
            }
            return (React.createElement(Wrap, { noBg: true, viewType: viewType },
                React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, dragHandleProps: dragHandleProps }),
                React.createElement(VideoWrap, { height: scHeight || 200 },
                    React.createElement("iframe", { width: '100%', height: '300', scrolling: 'no', frameBorder: 'no', allow: 'autoplay', src: updatedLink, onError: onError }))));
        }
    }
    // Если iframe не поддерживается, показываем его как есть без ошибки
    if (audioLink !== null && audioLink[1]) {
        var updatedLink = audioLink[1].substring(1, audioLink[1].length - 1);
        return (React.createElement(Wrap, { noBg: true, viewType: viewType },
            React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, dragHandleProps: dragHandleProps }),
            React.createElement(VideoWrap, { height: videoHeight },
                React.createElement("iframe", { style: {
                        border: 0,
                        width: '100%',
                        height: '200px',
                        background: 'transparent'
                    }, src: updatedLink, seamless: true, onError: onError }))));
    }
    return null;
};
export default AudioPost;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=audioblock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { POST_SHADOW } from '../../../../constants/theme';
import { RetryButton, VideoErrorCentered } from './videoblock';
import { Wrap } from '../editor/EditorToolbar/styles';
import { GeneralEditorOverlay } from '../editor/EditorOverlayNew/GeneralEditorOverlay';
import useCommonProps from '../../../../hooks/useCommonProps';
var VideoWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  iframe {\n    width: 100%;\n    height: ", "px;\n    box-shadow: ", ";\n  }\n"], ["\n  width: 100%;\n  iframe {\n    width: 100%;\n    height: ", "px;\n    box-shadow: ", ";\n  }\n"])), function (props) { return props.height; }, function (_a) {
    var viewType = _a.viewType;
    return viewType === 'shadow' ? POST_SHADOW : 'none';
});
var progressAnim = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    from {\n      width: 0%;\n    }\n\n    to {\n      width: 100%;\n    }\n"], ["\n    from {\n      width: 0%;\n    }\n\n    to {\n      width: 100%;\n    }\n"])));
var VideoError = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 30px;\n  line-height: 40px;\n  color: red;\n  padding: 20px;\n"], ["\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 30px;\n  line-height: 40px;\n  color: red;\n  padding: 20px;\n"])));
var checkAudioType = function (link) {
    var bcType = /^.*(bandcamp).*$/;
    var scType = /^.*(sound).*$/;
    var mbType = /^.*(mubert).*$/;
    if (link.match(bcType) !== null) {
        return 'bc';
    }
    if (link.match(scType) !== null) {
        return 'sc';
    }
    if (link.match(mbType) !== null) {
        return 'mb';
    }
    return 'nodata';
};
var AudioPost = function (props) {
    var post = props.post, isEditable = props.isEditable, colorStyle = props.colorStyle, dragHandleProps = props.dragHandleProps, viewType = props.viewType;
    var opts = {
        playerVars: {
            autoplay: 1
        }
    };
    var _a = useState(false), error = _a[0], setError = _a[1];
    var _b = useState(false), isVideo = _b[0], toggleVideo = _b[1];
    var _c = useState(200), videoHeight = _c[0], setVideoHeight = _c[1];
    var _d = useState(''), videoType = _d[0], setVideoType = _d[1];
    var _e = useState(''), audioLink = _e[0], setAudioLink = _e[1];
    var isFeed = useCommonProps().isFeed;
    useEffect(function () {
        var typedLink = checkAudioType(post.text);
        var link = post.text.match(/<iframe\s+.*?\s+src=(".*?").*?<\/iframe>/);
        setAudioLink(link);
        setVideoType(typedLink);
    }, []);
    var onError = function () { return setError(true); };
    if (error) {
        return (React.createElement(Wrap, { noBg: true, viewType: viewType },
            React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, withoutDrag: isFeed, dragHandleProps: dragHandleProps }),
            React.createElement(VideoWrap, { colorStyle: colorStyle, viewType: viewType },
                React.createElement(VideoErrorCentered, { colorStyle: colorStyle },
                    "\u041F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
                    React.createElement(RetryButton, { onClick: function () { return setError(false); } }, "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437")))));
    }
    if (audioLink !== null) {
        if (videoType === 'bc') {
            var updatedLink = audioLink[1].substring(1, audioLink[1].length - 1);
            console.log('updatedLink', updatedLink);
            return (React.createElement(Wrap, { noBg: true, viewType: viewType },
                React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, dragHandleProps: dragHandleProps }),
                React.createElement(VideoWrap, { height: videoHeight },
                    React.createElement("iframe", { style: {
                            border: 0,
                            width: '100%',
                            height: '120px',
                            background: 'transparent'
                        }, src: updatedLink, seamless: true, onError: onError }))));
        }
        if (videoType === 'mb') {
            var updatedLink = audioLink[1].substring(1, audioLink[1].length - 1);
            return (React.createElement(Wrap, { noBg: true, viewType: viewType },
                React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, dragHandleProps: dragHandleProps }),
                React.createElement(VideoWrap, { height: videoHeight },
                    React.createElement("iframe", { width: '380', height: '380', className: 'mubert-iframe mubert-widget', src: updatedLink, frameBorder: '0', allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', allowFullScreen: true, onError: onError }))));
        }
        if (videoType === 'sc') {
            var updatedLink = audioLink[1].substring(1, audioLink[1].length - 1);
            var scReg = post.text.match(/height="\s*(\d+)"/);
            var scHeight = void 0;
            if (scReg) {
                scHeight = +scReg[1];
            }
            return (React.createElement(Wrap, { noBg: true, viewType: viewType },
                React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, dragHandleProps: dragHandleProps }),
                React.createElement(VideoWrap, { height: scHeight || 200 },
                    React.createElement("iframe", { width: '100%', height: '300', scrolling: 'no', frameBorder: 'no', allow: 'autoplay', src: updatedLink, onError: onError }))));
        }
    }
    // Если iframe не поддерживается, показываем его как есть без ошибки
    if (audioLink !== null && audioLink[1]) {
        var updatedLink = audioLink[1].substring(1, audioLink[1].length - 1);
        return (React.createElement(Wrap, { noBg: true, viewType: viewType },
            React.createElement(GeneralEditorOverlay, { isEditable: isEditable, post: post, dragHandleProps: dragHandleProps }),
            React.createElement(VideoWrap, { height: videoHeight },
                React.createElement("iframe", { style: {
                        border: 0,
                        width: '100%',
                        height: '200px',
                        background: 'transparent'
                    }, src: updatedLink, seamless: true, onError: onError }))));
    }
    return null;
};
export default AudioPost;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=audioblock.js.map